"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonDownloadFile = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _react = require("react");

var _ButtonV = require("../../atoms/ButtonV2");

var _IconFile = require("../../atoms/IconFile");

var _axios = _interopRequireDefault(require("axios"));

var _utils = require("../../../global-files/utils");

var _jsxRuntime = require("react/jsx-runtime");

var ButtonDownloadFile = function ButtonDownloadFile(props) {
  var id = props.id,
      key = props.key,
      className = props.className,
      type = props.type,
      transparent = props.transparent,
      size = props.size,
      borderType = props.borderType,
      url = props.url,
      onDownload = props.onDownload;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showDownload = _useState2[0],
      setShowDownload = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var getSrc = function getSrc() {
    var temp = url.split("/");
    return temp[temp.length - 1];
  };

  var getFile = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var responseFile, newUrl, link;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              _context.next = 4;
              return (0, _axios.default)({
                url: url,
                method: "GET",
                responseType: "blob"
              });

            case 4:
              responseFile = _context.sent;

              if (!(responseFile.status !== 200)) {
                _context.next = 9;
                break;
              }

              setLoading(false);
              onDownload && onDownload({
                message: "No se pudo descargar el archivo",
                details: responseFile.statusText
              });
              return _context.abrupt("return");

            case 9:
              newUrl = window.URL.createObjectURL(new Blob([responseFile.data]));
              link = document.createElement("a");
              link.href = newUrl;
              link.setAttribute("download", getSrc());
              link.style.display = "none";
              document.body.appendChild(link);
              setLoading(false);
              link.click();
              document.body.removeChild(link);
              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](0);
              setLoading(false);
              onDownload && onDownload({
                message: "No se pudo descargar el archivo",
                details: _context.t0.message
              });

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 20]]);
    }));

    return function getFile() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      id: id,
      className: className,
      borderType: borderType,
      onMouseEnter: function onMouseEnter(event) {
        if (!showDownload) {
          setShowDownload(true);
        }
      },
      onMouseLeave: function onMouseLeave(event) {
        if (!loading) {
          setShowDownload(false);
        }
      },
      children: showDownload ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        className: "buttonDownload",
        type: type,
        transparent: transparent,
        size: size,
        borderType: borderType,
        icon: _freeSolidSvgIcons.faArrowDown,
        isLoading: loading,
        onClick: /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(event) {
            return _regenerator.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    getFile();

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }()
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconFile.IconFile, {
        className: "iconFile",
        type: type,
        transparent: transparent,
        size: size,
        borderType: borderType,
        ext: (0, _utils.getFileExtension)(getSrc())
      })
    }, key)
  });
};

exports.ButtonDownloadFile = ButtonDownloadFile;